import {
  CustomerBillingModel,
  CustomerLiteModel,
  CustomerModel,
} from 'api-hooks/customer';
import { EmployeeLiteModel } from 'api-hooks/employee';
import { SaleModel } from 'api-hooks/sale/common';
import { Expose, Type } from 'class-transformer';
import { TransactionalStatusEnum } from 'common/constants/enum';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

export class ReceiptDetailModel {
  id: string;

  @Type(() => SaleModel)
  sale: SaleModel;
}

export class ReceiptLiteModel extends CommonModel {
  description: string;
  number: string;
  status: string;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Expose({ name: 'download_count' })
  downloadCount: number;

  @Type(() => CustomerLiteModel)
  customer: CustomerLiteModel;

  @Expose({ name: 'customer_billing' })
  @Type(() => CustomerBillingModel)
  customerBilling: CustomerBillingModel | null;

  @Expose({ name: 'invoice_numbers' })
  invoiceNumbers: string[];

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;
}

export class ReceiptModel extends CommonModel {
  description: string;
  number: string;
  status: TransactionalStatusEnum;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Type(() => CustomerModel)
  customer: CustomerModel;

  @Expose({ name: 'customer_billing' })
  @Type(() => CustomerBillingModel)
  customerBilling: CustomerBillingModel | null;

  @Expose({ name: 'download_count' })
  downloadCount: number;

  @Expose({ name: 'receipt_details' })
  @Type(() => ReceiptDetailModel)
  receiptDetails: ReceiptDetailModel[];

  @Expose({ name: 'is_resolved' })
  isResolved: boolean;
}

//query
export type getReceiptsInput = {
  params: CommonParamInput;
};

export type getReceiptInput = {
  id: string;
};

//mutation
export type ReceiptMutationInput = {
  transactionAt: Date;
  needApproval: boolean;
  customerId: string;
  customerBillingId: string;
  description: string;
  receiptDetails: { id?: string; saleRefId: string; saleId: string }[];
};

export type ReceiptMutationUpdate = {
  id: string;
  body: ReceiptMutationInput;
};
export type ReceiptMutationVoid = {
  id: string;
};

export type PrintReceiptMutationInput = {
  id: string;
};

export type ReceiptUpdateStatusInput = {
  id: string;
  body: {
    action: 'complete' | 'revert-complete';
  };
};
